/** Factory the app uses. OWNER: INPUT agent — return your implementation here (keep the name). */
import type { InputSource } from '../types';
import { BO2Input } from './input';

export { BO2Input } from './input';

export function createInput(): InputSource {
  return new BO2Input();
}
